export default __webpack_public_path__ + "static/media/BGC-note-done.16643bae.svg";